
var _ = require('lodash')

var Helpers = require('src/common/helpers')


/**
 * The section is the base of a routine part
 * -----------------------------------------------------------------------------
 * Dimlevel section
 */
var Section = function (options) {
  this.options = options
  this.parent = options.parent
  this.stage = options.stage

  this.coords = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }

  this.prepare()
}

Section.prototype.prepare = function () {
  this.drawing = this.stage.rect(this.coords.width, this.coords.height).stroke({ width: 2, color: this.options.mainOptions.sectionBorderColor }).fill({ color: this.options.mainOptions.sectionColor})
  this.parent.sectionsGroup.add(this.drawing)
}
Section.prototype.draw = function () {
  this.drawing.size(this.coords.width, this.coords.height)
  this.drawing.move(this.coords.x, this.coords.y)
}
Section.prototype.move = function (x, y) {
  this.coords.x = x
  this.coords.y = y
  this.draw()
}
Section.prototype.size = function (width, height) {
  this.coords.width = width
  this.coords.height = height
  this.draw()
}
Section.prototype.width = function (width) {
  if (!width) return this.coords.width
  this.coords.width = width
  this.draw()
}
Section.prototype.height = function (height) {
  if (!height) return this.coords.height
  this.coords.height = height
  this.draw()
}

Section.prototype.x = function (x) {
  if (!x) return this.coords.x
  this.coords.x = x
  this.draw()
}
Section.prototype.y = function (y) {
  if (!y) return this.coords.y
  this.coords.y = y
  this.draw()
}
Section.prototype.remove = function () {
  this.drawing.remove()
}

module.exports.Section = Section

/**
 * RGB Section
 * -----------------------------------------------------------------------------
 *
 */
var RgbSection = function (options) {
  this.options = options
  this.parent = options.parent
  this.stage = options.stage

  this.coords = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }

  this.prepare()
}

RgbSection.prototype = Object.create(Section.prototype)
RgbSection.prototype.constructor = RgbSection

RgbSection.prototype.getProperties = function () {
  return this.parent.getProperties(this.options.sectionId)
}

RgbSection.prototype.refresh = function () {
  this.drawing.remove()
  this.prepare()
  this.draw()
}

RgbSection.prototype.prepare = function () {
  var properties = this.getProperties()

  this.drawing = this.stage.group()
  this.columnOne = this.stage.rect()
  this.columnTwo = this.stage.rect()
  this.columnDivisionBorder = this.stage.line(0, 0, 0, 0).stroke({ width: 2})
  this.columnRightBorder = this.stage.line(0, 0, 0, 0).stroke({ width: 1})

  this.drawing.add(this.columnOne)
  this.drawing.add(this.columnTwo)
  this.drawing.add(this.columnDivisionBorder)
  this.drawing.add(this.columnRightBorder)

  // styling
  this.columnOne.addClass('section-column-one')
  this.columnTwo.addClass('section-column-two')

  this.columnDivisionBorder.addClass('section-column-divider')
  this.columnDivisionBorder.addClass('column-color__' + properties.ring_one)

  this.columnRightBorder.addClass('section-column-border')

  // this.columnOne.addClass('column-one-color__'+properties[0])
  if (properties.ring_one) this.columnOne.addClass('column-color__' + properties.ring_one)
  if (properties.ring_two) this.columnTwo.addClass('column-color__' + properties.ring_two)

  // this.drawing = this.stage.rect(this.coords.width, this.coords.height).stroke({ width: 2, color: this.options.mainOptions.sectionBorderColor }).fill({ color: this.options.mainOptions.sectionColor})
  this.parent.sectionsGroup.add(this.drawing)
}

RgbSection.prototype.draw = function () {
  this.columnOne.size(this.coords.width, this.coords.height / 2)
  this.columnOne.move(this.coords.x, this.coords.y)
  this.columnTwo.size(this.coords.width, this.coords.height / 2)
  this.columnTwo.move(this.coords.x, this.coords.y + (this.coords.height / 2))

  this.columnDivisionBorder.plot(this.coords.x, this.coords.y + (this.coords.height / 2), this.coords.x + this.coords.width, this.coords.y + (this.coords.height / 2))
  this.columnRightBorder.plot(this.coords.x + this.coords.width, this.coords.y, this.coords.x + this.coords.width, this.coords.y + this.coords.height)
}

module.exports.RgbSection = RgbSection


/**
 * RGBW Section
 * -----------------------------------------------------------------------------
 *
 */
var RgbwSection = function (options) {
  this.options = options
  this.parent = options.parent
  this.stage = options.stage

  console.log('aoo')
  console.log(this.getProperties())
  this.coords = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }

  this.prepare()
}

RgbwSection.prototype.getProperties = function () {
  return this.parent.getProperties(this.options.sectionId)
}


RgbwSection.prototype.prepare = function () {
  var properties = this.getProperties()


  // add the "white value" to representational color

  var normalizedIntensity = Helpers.mapRange( [0,254], [  1, 0.3], parseInt(properties.color_w) );
  normalizedIntensity = 1;
  //console.log(parseInt(intensity));

  // if (forceOff) {
  //    normalizedIntensity = 0;
  // }

  let color = [
    (properties.color_r || 0) * normalizedIntensity,
    (properties.color_g || 0) * normalizedIntensity,
    (properties.color_b || 0) * normalizedIntensity
  ];


  // var colorObjectRgb = tinyColor({ r: ( color.red * normalizedIntensity ), g: ( color.green * normalizedIntensity ), b: ( color.blue * normalizedIntensity ) }).toRgb();
  //var colorObjectHsl = tinyColor({ h: colorObjectRgb.h, s: colorObjectRgb.s, l: 1 }).toRgb();
  //var colorObjectHsl = tinyColor({ r: color.red, g: color.green, b: color.blue }).toRgb();
  //console.log(colorObject);


  let hexColor = _.map(color, (decimal) => Helpers.dec2hex(parseInt(decimal))).join("");
  this.drawing = this.stage.rect(this.coords.width, this.coords.height).stroke({ width: 2, color: '#757575' }).fill({ color: "#"+hexColor})
  this.parent.sectionsGroup.add(this.drawing)
}
RgbwSection.prototype.draw = function () {
  
  this.drawing.size(this.coords.width, this.coords.height)
  this.drawing.move(this.coords.x, this.coords.y)
}

RgbwSection.prototype.refresh = function () {
  this.drawing.remove()
  this.prepare()
  this.draw()
}

RgbwSection.prototype.move = function (x, y) {
  this.coords.x = x
  this.coords.y = y
  this.draw()
}
RgbwSection.prototype.size = function (width, height) {
  this.coords.width = width
  this.coords.height = height
  this.draw()
}
RgbwSection.prototype.width = function (width) {
  if (!width) return this.coords.width
  this.coords.width = width
  this.draw()
}
RgbwSection.prototype.height = function (height) {
  if (!height) return this.coords.height
  this.coords.height = height
  this.draw()
}

RgbwSection.prototype.x = function (x) {
  if (!x) return this.coords.x
  this.coords.x = x
  this.draw()
}
RgbwSection.prototype.y = function (y) {
  if (!y) return this.coords.y
  this.coords.y = y
  this.draw()
}
RgbwSection.prototype.remove = function () {
  this.drawing.remove()
}

module.exports.RgbwSection = RgbwSection



// WEBPACK FOOTER //
// ./js/components/routine-composer/composer/section.js